import { InjectionToken } from "@angular/core";

import { CountriesApi } from "./countries.api.interface";

export const COUNTRIES_API = new InjectionToken<CountriesApi>('COUNTRIES_API');